/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemFromJSON, ItemToJSON, } from './Item.js';
/**
 * Check if a given object implements the ListJobApplicationRejectionReasonsResult interface.
 */
export function instanceOfListJobApplicationRejectionReasonsResult(value) {
    if (!('rejectionReasons' in value) || value['rejectionReasons'] === undefined)
        return false;
    return true;
}
export function ListJobApplicationRejectionReasonsResultFromJSON(json) {
    return ListJobApplicationRejectionReasonsResultFromJSONTyped(json, false);
}
export function ListJobApplicationRejectionReasonsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rejectionReasons': (json['rejectionReasons'].map(ItemFromJSON)),
    };
}
export function ListJobApplicationRejectionReasonsResultToJSON(json) {
    return ListJobApplicationRejectionReasonsResultToJSONTyped(json, false);
}
export function ListJobApplicationRejectionReasonsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rejectionReasons': (value['rejectionReasons'].map(ItemToJSON)),
    };
}
